class TestimonialCardsScroller extends HTMLElement {
  scrollContainer = undefined;
  itemWidth = undefined;

  constructor() {
    super();

    const arrow = this.querySelector("[data-scroller]");
    if (!arrow) return;

    try {
      this.scrollContainer = this.querySelector("[data-scroll-container]");
      this.itemWidth = this.querySelector("[data-item]").clientWidth;
      arrow.addEventListener("click", this.scroll.bind(this));
    } catch (error) {}
  }

  scroll() {
    // If at end of the scroll container, scroll back to the beginning.
    if (
      this.scrollContainer.scrollLeft + this.scrollContainer.clientWidth + 1 >=
      this.scrollContainer.scrollWidth
    ) {
      this.scrollContainer.scrollTo({
        left: 0,
        behavior: "smooth",
      });

      return;
    }

    this.scrollContainer.scrollBy({
      left: this.itemWidth * 2,
      behavior: "smooth",
    });
  }
}

customElements.define("testimonial-cards-scroller", TestimonialCardsScroller);
